const minus = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Typically used to minimize an active window of an application.",
    usage: "",
    category: "Content",
    tags: ["remove", "subtract"]
  },
  children: [{
    type: "path",
    props: {
      d: "M20 11.75a.749.749 0 0 0-.75-.75H4.75a.749.749 0 1 0 0 1.5h14.5c.414 0 .75-.333.75-.75z"
    }
  }]
};
export default minus;